import { LayoutType, withLayout } from 'hocs/with-layout';
import { SignUpOnboarding } from './signup-onboarding';

const WrappedSignUp = withLayout(LayoutType.WithOldNavOnly, SignUpOnboarding);

export { WrappedSignUp as SignUpOnboarding };
